{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Виберіть елемент",
  "tableResizer": "Засіб змінення розміру",
  "colorSwatchPicker": "Color swatches"
}
